import React, { useState } from "react";
import getModalStyle from "../../../util/getModalStyle";

type Dir = "left" | "right" | "up" | "down" | undefined;

function useTipsSelector() {
  const [modalStyle] = useState(() => getModalStyle(12, 40));

  const [page, setPage] = useState(0);

  const [direction, setDir] = useState<Dir>("right");

  const handlePageChange = (newPage: number, dir: Dir) => {
    setDir(dir);
    setPage((oldPage) => oldPage + newPage);
  };

  const [checked, setChecked] = useState(false);

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) =>
    setChecked(e.target.checked);

  return {
    handleCheck,
    checked,
    handlePageChange,
    direction,
    page,
    modalStyle,
  };
}

export default useTipsSelector;
